import script from "./LanguageChange.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageChange.vue?vue&type=script&setup=true&lang=js"

import "./LanguageChange.vue?vue&type=style&index=0&id=4bfc78c6&lang=scss"

const __exports__ = script;

export default __exports__